export default "__VITE_PUBLIC_ASSET__1449166f__"